/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../attachments/Attachments.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../../addresses/Addresses.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitOrderMutationVariables = Types.Exact<{
  orderId: Types.Scalars['ID']['input'];
}>;


export type SubmitOrderMutation = { submitOrder: { __typename: 'SubmitOrderResult', order: { __typename: 'Order', id: string, orderedDate?: any | null, file?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, calculationOrdered: { __typename: 'OrderCalculationOrdered', id?: string | null, quantityOrdered: number, priceOrdered: number, priceVatOrdered: number, priceTotalOrdered: number }, calculationPrepared: { __typename: 'OrderCalculationPrepared', id?: string | null, quantityOrdered: number, priceOrdered: number, priceVatOrdered: number, priceTotalOrdered: number } } } };

export type PurchaseOrderMarkAsOrderedButton_OrderFragment = { __typename: 'Order', id: string, crmSupplier?: { __typename: 'CrmCompany', id: string, title: string, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, items: Array<{ __typename: 'OrderItem', id: string }> };

export const PurchaseOrderMarkAsOrderedButton_OrderFragmentDoc = gql`
    fragment PurchaseOrderMarkAsOrderedButton_Order on Order {
  id
  crmSupplier {
    id
    title
    branchAddress {
      ...AddressDetails__Address
    }
    billingAddress {
      ...AddressDetails__Address
    }
  }
  items {
    id
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export const SubmitOrderDocument = gql`
    mutation SubmitOrder($orderId: ID!) {
  submitOrder(orderId: $orderId) {
    order {
      id
      orderedDate
      file {
        ...AttachmentSnapshot
      }
      calculationOrdered {
        id
        quantityOrdered
        priceOrdered
        priceVatOrdered
        priceTotalOrdered
      }
      calculationPrepared {
        id
        quantityOrdered
        priceOrdered
        priceVatOrdered
        priceTotalOrdered
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export type SubmitOrderMutationFn = Apollo.MutationFunction<SubmitOrderMutation, SubmitOrderMutationVariables>;

/**
 * __useSubmitOrderMutation__
 *
 * To run a mutation, you first call `useSubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOrderMutation, { data, loading, error }] = useSubmitOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSubmitOrderMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOrderMutation, SubmitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOrderMutation, SubmitOrderMutationVariables>(SubmitOrderDocument, options);
      }
export type SubmitOrderMutationHookResult = ReturnType<typeof useSubmitOrderMutation>;
export type SubmitOrderMutationResult = Apollo.MutationResult<SubmitOrderMutation>;
export type SubmitOrderMutationOptions = Apollo.BaseMutationOptions<SubmitOrderMutation, SubmitOrderMutationVariables>;